import { createMiddleware } from "@tanstack/react-start";

/**
 * Local replacement for the generated `attachSupabaseAuth` middleware.
 *
 * Behaviour is identical (attaches the Supabase bearer token to serverFn RPCs),
 * but the auth client is imported lazily so it stays out of the initial
 * browser bundle. Do not swap this back for the generated middleware.
 */
export const attachSupabaseAuth = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);
